import {
  addMonths, eachDayOfInterval, endOfMonth, endOfWeek, format, isSameDay,
  isSameMonth, startOfDay, startOfMonth, startOfWeek,
} from 'date-fns';
import { ru } from 'date-fns/locale/ru';
import { enUS } from 'date-fns/locale/en-US';
import { ro } from 'date-fns/locale/ro';

const LOCALES = { ru, en: enUS, ro };

export const dateLocale = (locale = 'ru') => {
  const key = String(locale).slice(0, 2);
  return LOCALES[key] || ru;
};

// Неделя начинается с воскресенья — как на макете.
const WEEK_OPTIONS = { weekStartsOn: 0 };

export const monthMatrix = (date) => {
  const from = startOfWeek(startOfMonth(date), WEEK_OPTIONS);
  const to = endOfWeek(endOfMonth(date), WEEK_OPTIONS);
  return eachDayOfInterval({ start: from, end: to });
};

export const weekDays = (date) =>
  eachDayOfInterval({ start: startOfWeek(date, WEEK_OPTIONS), end: endOfWeek(date, WEEK_OPTIONS) });

export const weekdayLabels = (locale) =>
  weekDays(new Date()).map((day) => format(day, 'EEE', { locale: dateLocale(locale) }));

// В списке и месяце листаем помесячно.
export const shiftPeriod = (date, view, direction) => addMonths(date, direction);

export const periodTitle = (date, view, locale) =>
  format(date, 'LLLL yyyy', { locale: dateLocale(locale) });

export const eventTime = (event, locale) =>
  format(new Date(event.start), 'HH:mm', { locale: dateLocale(locale) });

export const eventRange = (event, locale) => {
  const options = { locale: dateLocale(locale) };
  const start = format(new Date(event.start), 'HH:mm', options);
  const end = event.end ? format(new Date(event.end), 'HH:mm', options) : null;
  return end ? `${start} – ${end}` : start;
};

// Событие считается на дне, если день попадает в отрезок [start, end].
export const eventsOfDay = (events, day) =>
  events
    .filter((event) => {
      const start = startOfDay(new Date(event.start));
      const end = startOfDay(new Date(event.end || event.start));
      const target = startOfDay(day);
      return target >= start && target <= end;
    })
    .sort((a, b) => new Date(a.start) - new Date(b.start));

export const hasEvents = (events, day) => eventsOfDay(events, day).length > 0;

export const calendarById = (groups, calendarId) => {
  for (const group of groups) {
    const found = group.calendars.find((calendar) => calendar.id === calendarId);
    if (found) return found;
  }
  return null;
};

export const eventColor = (groups, event) => calendarById(groups, event.calendarId)?.color || '#64748b';

export { isSameDay, isSameMonth, format, startOfDay };
